export default "__VITE_ASSET__CdFOD$Ns__"